import React, { FC } from 'react'
import { Trans } from '@lingui/macro'

import { PathwayProgress } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { PathwayEnrolmentStatusEnum } from 'front-end/src/graphql/public/PublicSchemaTypes'

import Loader from '../../../components/common/loader/Loader'
import { linkBuilder } from '../../../../../shared/linkBuilder'
import CircleProgress from '../../../components/common/circle-progress/CircleProgress'
import IconX from '../../../components/common/icon/IconX'
import { usePathwayEnrolmentProgressQuery } from './PathwayCompletedMessage.codegen'

import './PathwayCompletedMessage.less'

interface IProps {
  pathwayId: number
}

export const PathwayCompletedMessage: FC<IProps> = ({ pathwayId }) => {
  const { data, loading } = usePathwayEnrolmentProgressQuery({
    variables: { pathwayId }
  })

  if (loading) {
    return <Loader />
  }
  if (!data?.pathway?.progress) {
    return null
  }
  const { pathway } = data

  if (
    !pathway?.currentEnrolment ||
    (pathway.progress !== PathwayProgress.locked &&
      pathway?.currentEnrolment?.progress !== 100)
  ) {
    return null
  }

  const isFailed =
    pathway.currentEnrolment?.status === PathwayEnrolmentStatusEnum.FAILED
  const isCompleted =
    pathway.currentEnrolment?.status === PathwayEnrolmentStatusEnum.COMPLETED

  if (isFailed) {
    return (
      <div className="PathwayCompletedMessage">
        <IconX size="large" />
        <div>
          <h4>
            <Trans>You have failed the {pathway.title} pathway</Trans>
          </h4>
        </div>
      </div>
    )
  }

  if (isCompleted) {
    return (
      <a
        className="PathwayCompletedMessage"
        href={linkBuilder.pathwayDetail(pathway.id)}
      >
        <CircleProgress
          progress={1}
          completed={true}
          lineWidth={8}
          lineColor={'#00BB77'}
          backgroundColor="rgba(255, 255, 255, 0)"
          backgroundLineColor="rgba(220, 220, 220, .5)"
        >
          <div className="arrow-right" />
        </CircleProgress>
        <div>
          <p>
            <Trans>Congratulations!</Trans>
          </p>
          <h4>
            <Trans>You have completed the {pathway.title} pathway</Trans>
          </h4>
        </div>
      </a>
    )
  }

  return null
}
